<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen">
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>
		
		<div class="content">
			<div class="container">
				
				<div class="card box-shadow mt-4">
					<div class="card-body">
						<h5 class="card-title">Lubricantes</h5>
						<p class="card-text">Listar lubricantes para que vaya seleccionando e indicando cantidades</p>
						<LubricantsInput v-model="form.lubricants"></LubricantsInput>
						<div class="invalid-feedback d-block" v-if="validation.hasError('form.lubricants')">Si usó un lubricante indique la cantidad utilizada en Litros</div>
					</div>	
				</div>

				<!-- <div class="card box-shadow mt-4">
					<div class="card-body">
						<h5 class="card-title">Mano de obra</h5>
						<p class="card-text">Indique la cantidad de horas trabajadas</p>
						<div class="invalid-feedback d-block" v-if="validation.hasError('form.labor_hours')">Ingrese la cantidad de horas trabajadas</div>
					</div>
					<div class="card-action">
						<div class="input-group mb-3" style="width:120px;">
							<date-picker 
								v-model="form.labor_hours" 
								type="time"
								:minute-step="15"
								:show-second="false"
								:format="'HH:mm'"
							></date-picker>
						</div>
					</div>				
				</div> -->
				
				<div class="card box-shadow mt-4">
					<div class="card-body">
						<h5 class="card-title">Pulido</h5>
						<p class="card-text">Indique si se ha pulido el auto en su totalidad o cierta cantidad de piezas</p>
						<div class="invalid-feedback d-block" v-if="validation.hasError('form.polished')">Establezca la cantidad de piezas pulidas</div>
					</div>
					<div class="card-action">
						<!-- <toggle-button 
							:value="true"
							v-model="form.polished"
							:width="80"
							:color="{checked: 'rgb(212, 187, 9)', unchecked: '#75C791'}"
							:labels="{checked: 'Parcial', unchecked: 'Total'}"
						/> -->

						<div class="btn-group" role="group" aria-label="Basic example">
							<button type="button" @click="form.polished='total'" class="btn btn-xs" :class="form.polished=='total' ? 'btn-success':'btn-light'">Total</button>
							<button type="button" @click="form.polished='partial'" class="btn btn-xs" :class="form.polished=='partial' ? 'btn-success':'btn-light'">Parcial</button>
							<button type="button" @click="form.polished='none'" class="btn btn-xs" :class="form.polished=='none' ? 'btn-success':'btn-light'">No</button>
						</div>
						<div class="input-group mb-3" v-if="form.polished=='partial'" style="width:120px;">
							<div class="input-group-prepend">
								<span class="input-group-text">N piezas</span>
							</div>
							<input type="number" step="1" class="form-control text-right" 
							placeholder="N" v-model="form.polished_pieces" >
						</div>
					</div>
				</div>
				
				<div class="card box-shadow mt-4">
					<div class="card-body">
						<h5 class="card-title">Carga de gas</h5>
						<p class="card-text">
							Indique si ha realizado o no la carga de gas del aire acondicionado
						</p>
					</div>
					<div class="card-action">
						<toggle-button 
							:value="true"
							v-model="form.gas_charge"
							:labels="{checked: 'Si', unchecked: 'No'}"
						/>
					</div>
				</div>
				
				<div class="card box-shadow mt-4">
					<div class="card-body">
						<h5 class="card-title">¿Se han detectado daños?</h5>
						<p class="card-text">
							Si ha encontrado algún detalle o daño, marque esta opción y describa todo en las observaciones generales.
						</p>
					</div>
					<div class="card-action">
						<toggle-button 
							:value="true"
							v-model="form.has_damages"
							:labels="{checked: 'Si', unchecked: 'No'}"
						/>
					</div>
				</div>
				
				<div class="card box-shadow mt-4 mb-4">
					<div class="card-body">
						<h5 class="card-title">Observaciones generales</h5>
						
						<b-form-group label="Comentarios" class="mt-4">
							<textarea-autosize
							placeholder="Comentarios"
							v-model="form.comments"
							:min-height="30"
							:max-height="350"
							class="form-control"
							/>
						</b-form-group>
						
						<b-form-group label="Archivos adjuntos" class="mt-4">
							<UploadMultiple
								v-model="form.images" 
								:placeholder="'Adjuntar archivo'" 
							></UploadMultiple>
						</b-form-group>

					</div>
				</div>
				
			</div>
		</div>

		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="finishControl()">
					Finalizar
				</div>
			</div>
		</div>

	</div>

	<ControlSuccess 
		v-if="control.step=='ControlSuccess'"
		:control="controlCreated"
	></ControlSuccess>

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'
import LubricantsInput from '@/components/LubricantsInput'
import UploadMultiple from '@/components/UploadMultiple'

import ControlSuccess from '@/views/controls/ControlSuccess'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'CarPreDelivery',
	mixins:[mixins],
	components: {
		Loader,
		LubricantsInput,
		UploadMultiple,
		ControlSuccess
	},
	data(){
		return{
			loading: false,
			saving: false,
			API_URL: process.env.VUE_APP_API_URL,
			controlCreated: null,
			form:{
				lubricants: [],
				labor_hours:null,
				polished:'none',
				polished_pieces: 0,
				gas_charge:false,
				has_damages:false,
				comments:null,
				images: [],
			},
		}
	},
	computed: {
		...mapState(['control'])
	},
	validators: {
		'form.lubricants': function (value) {
			return Validator.custom( () => {
				var error = false
				if(value.length>0){
					
					value.forEach(item => {
						if( !item.lubricant_id || item.lubricant_id<=0 || !item.liters || item.liters<=0 ){
							error = true
						}
					})
				}
				return error
			})
		},
		// 'form.labor_hours': function (value) {
		// 	return Validator.custom( () => {
		// 		var error = false
		// 		if( !value){
		// 			error = true
		// 		}else{
		// 			var date = this.$moment(value)
		// 			if(!date.isValid()){
		// 				error = true
		// 			}
		// 		}
		// 		return error
		// 	})
		// },
		'form.polished': function (value) {
			return Validator.custom( () => {
				var error = false
				if( value == 'partial' ){
					if(this.form.polished_pieces<=0){
						error = true
					}
				}
				return error
			})
		},
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		async finishControl(){
			if(!this.saving && await this.checkValidation() ) {
				this.$dialog
				.confirm('Confirmar pre entrega',{
					cancelText: 'Cancelar',
					okText: 'Confirmar'
				})
				.then(() => {
					this.finishControlOK()
				})
			}
		},
		async finishControlOK(){
			this.saving = true
			// var labor_hours = this.$moment(this.form.labor_hours).format("YYYY-MM-DD HH:mm:ss")
			let imagesIds = this.form.images.map(a => a.id)
			let dataInput = {
				car_id 			: this.control.car.id,
				lubricants		: this.form.lubricants,
				// labor_hours		: labor_hours,
				polished		: this.form.polished,
				polished_pieces	: this.form.polished_pieces,
				gas_charge		: this.form.gas_charge,
				has_damages		: this.form.has_damages,
				comments		: this.form.comments,
				files			: imagesIds
			}
			return this.$apollo.mutate({
				mutation: gql`mutation ( $data:ControlPreDeliveryInput! ){
					controlPreDelivery( data: $data) {
						id
						car{
							id
						}
						user{
							name
						}
						type
						typeText
						lubricants{
							lubricant{
								title
							}
							liters
						}
						labor_hours
						polished
						polished_pieces
						gas_charge
						has_damages
						comments
						files{
							id
							url
							urlThumb
						}
						created_at
					}
				}`,
				variables: {
					data: dataInput
				}
			})
			.then((data) => {
				this.controlCreated = data.data.controlPreDelivery
				this.saving = false
				this.control.step = 'ControlSuccess'
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
